import type { RouteRecordRaw } from "vue-router";
import StatsPage from "./StatsPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/stats",
    name: "stats",
    component: StatsPage,
  },
];

export default routes;
